import petal from "@assets/icons/generic/petal_new.png"
import xpSquare from "@assets/icons/generic/xp_square.png"
import LogoutButton from "@common/account/LogoutButton"
import ValidateEmailActionCard from "@common/account/ValidateEmailActionCard"
import TextButtonM from "@common/components/button/TextButtonM"
import TitleM from "@common/components/text/TitleM"
import { HeaderContainerM } from "@common/header/HeaderContainerM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { authService } from "@data/services/authService"
import { skillSetsService } from "@data/services/skillSetsService"
import { AbilityContext } from "@data/utility/Can"
import { useNavigation, useRoute } from "@react-navigation/native"
import React, { useContext, useState } from "react"
import {
    Dimensions,
    RefreshControl,
    ScrollView,
    View,
} from "react-native"
import { StatusBar } from "@common/systemBars/StatusBar"
import { IconButton } from "react-native-paper"
import { connect } from "react-redux"
import { SkillSetTitleFull } from "../../common/components/statistics/Counters"
import { StatisticsItemProfile } from "../../common/components/statistics/StatisticItemProfile"
import { hasRole } from "../../data/utility/ability"
import { ActivitiesStatistics } from "../progress/ActivitiesStatistics"
import { ProfileInfo } from "../social/ProfileInfo"
import AccountProgression from "./AccountProgression"
import ChooseTitleModal from "./ChooseTitleModal"
import CustomizableAvatar from "./CustomizableAvatar"
import CompleteProfileCard from "./profile/CompleteProfileCard"
import { ProfileSection } from "./ProfileSection"
import StripeExpressDashboardButton from "./StripeExpressDashboardButton"

const getMostAdvancedSkillSet = (skillSets) => {
    if (!skillSets || skillSets.length === 0) {
        return null
    }

    return skillSets.reduce((mostAdvanced, current) => {
        if (!current.steps || current.steps.length === 0) {
            return mostAdvanced
        }

        const currentRatio = (current.current_step - 1) / current.steps.length
        const mostAdvancedRatio = mostAdvanced
            ? mostAdvanced.current_step / mostAdvanced.steps.length
            : 0

        return currentRatio >= mostAdvancedRatio ? current : mostAdvanced
    }, null)
}

const MyAccountScreen = (props) => {
    const navigation = useNavigation()
    const route = useRoute()
    const [chooseTitleModalVisible, setChooseTitleModalVisible] =
        useState(false)
    const showChooseTitleModal = () => setChooseTitleModalVisible(true)
    const hideChooseTitleModal = () => setChooseTitleModalVisible(false)

    const ability = useContext(AbilityContext)

    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "flex-start",
                width: Dimensions.get("window").width,
                alignSelf: "center",
            }}
        >
            <HeaderContainerM style={{ justifyContent: "space-between" }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <IconButton
                        icon={"times"}
                        iconColor={theme.colors.primary}
                        containerColor={theme.colors.transparent}
                        size={32}
                        style={{}}
                        onPress={() => {
                            navigation.goBack()
                        }}
                    />
                    <TitleM>Mon compte</TitleM>
                </View>
                <IconButton
                    icon={"cog"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{}}
                    onPress={() => {
                        navigation.push("settings", { initialTab: 0 })
                    }}
                />
            </HeaderContainerM>
            <ScrollView
                refreshControl={
                    <RefreshControl
                        refreshing={!!props.getUserRequest}
                        onRefresh={() => {
                            props.apiRequest(authService.getUser)
                            props.apiRequest(skillSetsService.getSkillSets)
                        }}
                    />
                }
                style={{
                    width: "100%",
                }}
                contentContainerStyle={{
                    alignItems: "center",
                    width: dimensions?.width,
                    alignSelf: "center",
                }}
            >
                <ValidateEmailActionCard />
                <CompleteProfileCard />

                <ProfileSection
                    title={props.user?.display_name}
                    style={{
                        paddingBottom: 20,
                        paddingTop: 20,
                        width: "100%",
                    }}
                    noBorder
                >
                    <View
                        style={{
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                        }}
                    >
                        <View
                            style={{
                                flex: 1,
                            }}
                        >
                            <ProfileInfo
                                user={props.user}
                                showEmail={false}
                                showSchoolSubjects={ability.can(
                                    "read",
                                    "my_successes"
                                )}
                            />
                        </View>
                        <View
                            style={{
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 10,
                                marginLeft: 10,
                            }}
                        >
                            <CustomizableAvatar
                                user={props.user}
                                autoOpenAIModal={
                                    route.params?.openAIAvatarModal === true
                                }
                            />

                            {hasRole(props.user, "student") && (
                                <>
                                    <SkillSetTitleFull
                                        title={props?.user?.student_title}
                                        icon={props?.user?.student_title_icon}
                                        skillSetId={
                                            props?.user?.title_skill_set_id
                                        }
                                        onPress={showChooseTitleModal}
                                        style={{ marginTop: 8 }}
                                    />
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginTop: 8,
                                        }}
                                    >
                                        <StatisticsItemProfile
                                            source={xpSquare}
                                            color={theme.colors.accentDark}
                                            count={props.user?.xp}
                                        />

                                        <StatisticsItemProfile
                                            source={petal}
                                            color={theme.colors.petalNew}
                                            count={props.user?.petals}
                                        />
                                    </View>
                                </>
                            )}
                        </View>
                    </View>

                    {/* {hasRole(props.user, "student") && (
                            <PedagogicalObjectivesSection
                            student={props.user}
                            schoolSubjects={props.user?.school_subjects}
                        />
                    )} */}
                    {ability.can("read", "my_successes") && (
                        <View
                            style={{
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: 30,
                                width: "100%",
                            }}
                        >
                            <AccountProgression
                                title="Quêtes"
                                style={{
                                    borderRadius: 15,
                                    borderWidth: 1,
                                    borderColor: theme.colors.lightMore,
                                    marginVertical: 4,
                                }}
                                onPress={() => {
                                    navigation.push("skill-set")
                                }}
                                variant="quest"
                                skillSet={getMostAdvancedSkillSet(
                                    props.user?.skill_sets
                                )}
                            />
                            <AccountProgression
                                title="Classements"
                                color={theme.colors.accentLighter}
                                style={{
                                    borderRadius: 15,
                                    borderWidth: 1,
                                    borderColor: theme.colors.lightMore,
                                    marginVertical: 4,
                                }}
                                onPress={() => {
                                    navigation.push("ranking")
                                }}
                                variant="ranking"
                            />
                            <AccountProgression
                                title="Gestes"
                                color={theme.colors.petalNewLighter}
                                style={{
                                    borderRadius: 15,
                                    borderWidth: 1,
                                    borderColor: theme.colors.lightMore,
                                    marginVertical: 4,
                                }}
                                onPress={() => {
                                    navigation.push("shop")
                                }}
                                variant="shop"
                            />
                        </View>
                    )}

                    {ability.can("read", "my_students") && (
                        <TextButtonM
                            onPress={() => {
                                navigation.push("tutor/ma-dispo")
                            }}
                            style={{
                                paddingHorizontal: 4,
                            }}
                            fontWeight={"Bold"}
                            label="MA DISPO"
                        />
                    )}

                    {ability.can("read", "my_students") && (
                        <TextButtonM
                            onPress={() => {
                                navigation.push("tutoring-invoices")
                            }}
                            // TextButtonM carries no vertical margin of its own, so
                            // each link in this run spaces itself — same marginTop
                            // as the two Stripe links below.
                            style={{
                                paddingHorizontal: 4,
                                marginTop: 10,
                            }}
                            fontWeight={"Bold"}
                            label="MES FACTURES"
                        />
                    )}

                    <StripeExpressDashboardButton />
                </ProfileSection>

                {ability.can("read", "my_successes") &&
                    !!props.user?.statistics && (
                        <ProfileSection
                            title={"Mes statistiques"}
                            style={{ width: "100%" }}
                        >
                            <ActivitiesStatistics
                                style={{ marginTop: 25, marginBottom: 15 }}
                                user={props.user}
                            />
                        </ProfileSection>
                    )}

                <LogoutButton />
            </ScrollView>

            <ChooseTitleModal
                visible={chooseTitleModalVisible}
                onDismiss={hideChooseTitleModal}
            />

            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        isResendingEmail: state.api.emailResend?.request,
        resentEmail: state.api.emailResend?.success,
        resendEmailError: state.api.emailResend?.error,

        loggingOut: state.api.revokeSanctumToken?.request,
        loggedOut: state.api.revokeSanctumToken?.success,
        error: state.api.revokeSanctumToken?.error,

        unsubscribeFromNotificationsRequest:
            state.api.unsubscribeFromNotifications?.request,
        unsubscribeFromNotificationsSuccess:
            state.api.unsubscribeFromNotifications?.success,
        unsubscribeFromNotificationsError:
            state.api.unsubscribeFromNotifications?.error,

        user: state.data.currentUser?.object,
        expoToken: state.data.session?.object?.expo_token,

        getUserRequest: state.api.getUser?.request,

        successes: state.data.staticData?.successes,
        avatars: state.data.staticData?.avatars,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountScreen)
